import React, { useState, useEffect } from 'react';
import { useGetAll } from '../hooks/CommissionsHook';
import { shallowEqual, useSelector } from 'react-redux';
import { UserModel } from '../../../../modules/auth/models/UserModel';
import { RootState } from '../../../../../setup';
import {
  KTSVG,
  userHasRole,
  SimpleAlert,
  LoadingGrid,
} from '../../../../../_mexablock/helpers';
import { Filter } from '../_modals/Filter';
import { downloadPDF } from '../../../../service/reportes/Commissions';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { parseAxiosError } from '../../../../service/reportes/AccountStatment';

let fechaActual = new Date();
let fecha_inicio_init = new Date(
  fechaActual.getFullYear(),
  fechaActual.getMonth() - 1,
  1
);
let fecha_fin_init = new Date();

const View: React.FC = () => {
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as UserModel;
  const { roles: userRoles } = user;
  const showFilterCode = userHasRole(
    ['SYSTEM_ADMIN', 'ADMIN_MEXABLOCK', 'ADMIN_PARTNER'],
    userRoles
  );
  const [loadingView, setloadingView] = useState(true);
  const [initFilterValues, setInitFilterValues] = useState({
    codeAccount: '',
    init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
    end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
    filter: 0,
  });
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);
  const [loadingDownload, setloadingDownload] = useState(false);

  useEffect(() => {
    if (data.length) {
      setloadingDownload(false);
    } else {
      setloadingDownload(true);
    }
  }, [data]);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };
  const handleFilterClean = () => {
    setInitFilterValues({
      codeAccount: '',
      init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
      end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
      filter: 0,
    });
  };

  const columns: any = [
    {
      id: 'fecha',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => row.fechaFormat,
      cell: (row: any) => row.fecha,
      sortable: true,
      width: '280px',
    },
    {
      id: 'operacion',
      name: <div className="fw-bolder text-muted me-5">Operación</div>,
      selector: (row: any) => row.operacion,
      sortable: true,
      width: '150px',
    },

    // {
    //   id: 'tipoMovimiento',
    //   name: <div className="fw-bolder text-muted me-5">Tipo Mov</div>,
    //   selector: (row: any) => row.tipoMovimiento,
    //   sortable: true,
    //   width: '120px',
    // },
    {
      id: 'tipoMovimiento',
      name: <div className="fw-bolder text-muted me-5">Tipo Mov</div>,
      selector: (row: any) => row.tipoMovimiento,
      cell: (row: any) => {
        return row.tipoMovimiento === 'Abono' ? (
          <span className="text-success fw-bolder">{row.tipoMovimiento}</span>
        ) : (
          <span className="text-danger fw-bolder">{row.tipoMovimiento}</span>
        );
      },
      sortable: true,
      width: '120px',
    },
    {
      id: 'concepto',
      name: <div className="fw-bolder text-muted me-5">Concepto</div>,
      selector: (row: any) => row.concepto,
      sortable: true,
      width: '120px',
    },
    {
      id: 'tipoSaldo',
      name: <div className="fw-bolder text-muted me-5">Tipo de saldo</div>,
      selector: (row: any) => row.tipoSaldo,
      sortable: true,
      width: '150px',
    },
    {
      id: 'monto',
      name: <div className="fw-bolder text-muted me-5">Monto</div>,
      selector: (row: any) => row.montoFormat,
      cell: (row: any) => row.monto,
      sortable: true,
      width: '150px',
    },
    {
      id: 'cuentaComision',
      name: <div className="fw-bolder text-muted me-5">Cuenta comisión</div>,
      selector: (row: any) => row.cuentaComision,
      sortable: true,
      width: '170px',
    },
    {
      id: 'usuario',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) => row.usuario,
      sortable: true,
      width: '200px',
    },
  ];

  const handleDownloadPDF = () => {
    setloadingDownload(true);
    setTimeout(() => {
      downloadPDF(initFilterValues)
        .then(() => {
          setloadingDownload(false);
        })
        .catch(async (error) => {
          setloadingDownload(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
                showFilterCode={showFilterCode}
                userRoles={userRoles}
              />
              <div className="card-toolbar">
                <button
                  className="btn btn-sm btn-light-danger ms-5"
                  disabled={loadingDownload}
                  onClick={handleDownloadPDF}
                >
                  {loadingDownload && data.length ? (
                    <span
                      className="indicator-progress"
                      style={{ display: 'block' }}
                    >
                      Descargando...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  ) : (
                    <>
                      <KTSVG
                        path="/media/icons/duotune/files/fil009.svg"
                        className="svg-icon-5 svg-icon-gray-500 me-1"
                      />
                      Descargar PDF
                    </>
                  )}
                </button>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
